import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createDisputeHierarchy,
  deleteDisputeHierarchy,
  fetchDisputeComments,
  fetchDisputeHierarchy,
  getAllDisputes,
  getAllRaisedDisputes,
  hasDisputeHierarchy,
  HasDisputeHierarchy,
  postDisputeComment,
  submitDispute,
  updateDisputeHierarchy,
  updateDisputeStatus,
} from "../../../services/disputeService";

export const submitDisputeThunk = createAsyncThunk(
  "dispute/submit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await submitDispute(payload);
      return response.data; // adjust if your apiClient wraps response
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getAllDisputesThunk = createAsyncThunk(
  "dispute/fetchAll",
  async (CustomerId, { rejectWithValue }) => {
    try {
      const response = await getAllDisputes(CustomerId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getAllRaisedDisputesThunk = createAsyncThunk(
  "dispute/fetchraisedAll",
  async (TeamID, { rejectWithValue }) => {
    try {
      const response = await getAllRaisedDisputes(TeamID);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const updateDisputeStatusThunk = createAsyncThunk(
  "dispute/updateStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateDisputeStatus(payload);
      return response; // adjust if your apiClient returns response.data
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// disputeThunks.js
export const fetchDisputeCommentsThunk = createAsyncThunk(
  "dispute/fetchComments",
  async (disputeId, { rejectWithValue }) => {
    try {
      const response = await fetchDisputeComments(disputeId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const postDisputeCommentThunk = createAsyncThunk(
  "dispute/postComment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postDisputeComment(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const createDisputeHierarchyThunk = createAsyncThunk(
  "disputeHierarchy/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createDisputeHierarchy(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const updateDisputeHierarchyThunk = createAsyncThunk(
  "disputeHierarchy/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateDisputeHierarchy(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const deleteDisputeHierarchyThunk = createAsyncThunk(
  "disputeHierarchy/delete",
  async ({ custId, catId }, { rejectWithValue }) => {
    try {
      await deleteDisputeHierarchy(custId, catId);
      return { custId, catId };
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchDisputeHierarchyAsync = createAsyncThunk(
  "disputeHierarchy/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchDisputeHierarchy();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

//  restict to raised disupte if hierarchy is not set
export const fetchDisputeHierarchyThunk = createAsyncThunk(
  "dispute/fetchHierarchy",
  async ({ custId, catId }, { rejectWithValue }) => {
    try {
      const response = await hasDisputeHierarchy(custId, catId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);